export abstract class CustomError extends Error {
  name: string = this.constructor.name;
}
